module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogged) ? _c('div', {
    staticClass: "chat-container"
  }, [_c('div', {
    staticClass: "chat-float",
    class: {
      open: _vm.open
    }
  }, [_c('chat-usuarios', {
    ref: "chatUsuarios",
    staticClass: "chat-content",
    attrs: {
      "filter-key": _vm.filterKey
    }
  }), _vm._v(" "), _c('u-chat-menu-options', {
    on: {
      "pesquisa": _vm.pesquisaUsuario
    }
  })], 1), _vm._v(" "), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-conversas"
  }, [_c('div', {
    staticClass: "chat-conversas-container",
    attrs: {
      "id": "chat-conversas-container"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56b4e61c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/chat/components/Chat.vue
// module id = 1677
// module chunks = 17